import { IStakingPeriod } from "../interfaces/staking.interface";
import { StakePeriodType, StakingType } from "../enums/staking.enum";

export const stakingPeriods: IStakingPeriod[] = [
  {
    days: 30,
    apy: 6,
    disabled: false,
    stakePeriod: StakePeriodType.OneMonth,
  },
  {
    days: 90,
    apy: 12,
    disabled: false,
    stakePeriod: StakePeriodType.ThreeMonths,
  },
  {
    days: 180,
    apy: 16,
    disabled: false,
    stakePeriod: StakePeriodType.SixMonths,
  },
  {
    days: 360,
    apy: 20,
    disabled: false,
    stakePeriod: StakePeriodType.TwelveMonths,
  },
];

export const stakingOption = [
  {
    title: "UNQ Token",
    disabled: false,
    type: StakingType.UnqToken,
  },
  {
    title: "UNQ 1001 NFT",
    disabled: false,
    type: StakingType.UnqNFT,
  },
];

export const INITIAL_STAKING_CARDS_COUNT = 8;
export const STAKING_CAP_AMOUNT = 500000;
export const UNSTAKING_LOCK_PERIOD = 21;
export const MONTHS_PER_YEAR = 12;
export const DAYS_PER_MONTH = 30;
export const MAX_ACTIVE_STAKING_ACCOUNTS = 4;
